import { gql, TypedDocumentNode } from 'apollo-angular';

import {
  IGetOrganizationByShortNameInput,
  IGetOrganizationByShortNameResult,
} from '@shared/models/organization';
import { ORGANIZATION_FRAGMENT } from '@graphql/fragments/organization.fragment';

export const GET_ORGANIZATION_BY_SHORT_NAME: TypedDocumentNode<
  IGetOrganizationByShortNameResult,
  IGetOrganizationByShortNameInput
> = gql`
  ${ORGANIZATION_FRAGMENT}
  query getOrganizationByShortName(
    $shortName: String!
    $campaignName: String
    $refCode: String
  ) {
    getOrganizationByShortName(
      shortName: $shortName
      campaignName: $campaignName
      refCode: $refCode
    ) {
      ...OrganizationFragment
    }
  }
`;
